<template>
	<UITopHeading>Login</UITopHeading>
	<div class="container flex flex-col items-center">
		<div>
			<div class="md:mx-8">
				<p class="mb-6">
					Der Login für deinen persönlichen Propellerbereich und dein Ticket.
				</p>
				<UserLogin />
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
useSeoMeta({
	title: 'Login',
	ogTitle: 'Login',
	twitterTitle: 'Login',
	description:
		'Der Login für deinen persönlichen Propellerbereich und dein Ticket.',
	ogDescription:
		'Der Login für deinen persönlichen Propellerbereich und dein Ticket.',
	twitterDescription:
		'Der Login für deinen persönlichen Propellerbereich und dein Ticket.',
	ogUrl: 'https://propellerfestival.de/login',
})
</script>

<style scoped></style>
